import { message, Table, TableColumnsType, Tag } from 'antd';
import { Form, Formik } from 'formik';
import { observer } from 'mobx-react-lite';
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { TEXT_BUTTON_HEADER_LIST } from '../../../config/config';
import { PermissionShipping } from '../../../permissions/PermissionShipping';
import productStore from '../../../stores/productStore';
import BreadCrumbComponent from '../../atoms/BreadCrumbComponent';
import ActionButton from '../../atoms/ButtonComponent';
import FileUpload from '../../atoms/FileUploadComponent';
import PermissionComponent from '../../atoms/PermissionComponent';
import ContentBox from '../../molecules/ContentBox';
import LoadingWrapper from '../../molecules/LoadingWrapper';
import Permission from '../../molecules/Permission';

const breadCrumb = [
    {
        title: <Link to="/dashboard">Dashboard</Link>,
    },
    {
        title: <p>Upload de Produto em Massa</p>,
    },
]

interface DataType {
    active: boolean;
    hexColorCode: string;
    shortName: string;
    name: string;
    uuid: string;
    key: React.Key;
}

const CreateMassProductInclusion: React.FC = observer(() => {
    const [uploadFile, setUploadFile] = useState();
    const navigate = useNavigate();
    const listRouter = () => { navigate(`/fretes`); }
    const { productMassListError, loading } = productStore;

    const initialValues = {
    };

    // Faz o filtro da tabela
    const handleSubmit = async () => {
        if (uploadFile) {
            await productStore.massProductUpload(uploadFile);
        } else {
            message.success('Nenhum Arquivo Selecionado');
        }
    };


    const handleFileProcessed = async (file: any) => {
        setUploadFile(file);
    };


    const columns: TableColumnsType<DataType> = [
        {
            title: 'Linha',
            dataIndex: 'line',
            key: 'line',
            sorter: false,
        },
        {
            title: 'Mensagem',
            dataIndex: 'message',
            key: 'message',
            sorter: false,
        },
        {
            title: 'Status',
            dataIndex: 'active',
            key: 'active',
            render: () => {
                return (
                    <Tag color={'red'}><p>Erro</p></Tag>
                );
            },
        },
    ];

    const handleExport = () => {
        const link = document.createElement("a");
        link.href = "assets/documents/ModeloCadastroProdutoMassa.csv";
        link.download = "ModeloCadastroProdutoMassa.csv";
        link.click();
    };

    return (
        <>
            <BreadCrumbComponent breadCrumbList={breadCrumb} textButton={TEXT_BUTTON_HEADER_LIST} onClick={() => listRouter()} />


            <Permission
                permissionKeys={[PermissionShipping.POST, PermissionShipping.GET]}
                fallback={<PermissionComponent />}
            >
                <Formik
                    initialValues={initialValues}
                    onSubmit={handleSubmit}
                >
                    <Form>
                        <ContentBox className="mb-4 p-6" title="Inclusão de Produto em Massa" description='Tela para importação de Produtos em Massa'>
                            <div className="flex pt-3 gap-4 items-end">
                                <div className="w-full">
                                    <FileUpload returnOriginalFile={true} validateFilledFields={false} accept=".csv" title="Selecione o arquivo" onFileProcessed={handleFileProcessed} requiredColumns={
                                        [
                                            // 'SKU (!)',
                                            'Nome (!)',
                                            // 'Nome Curto (!)',
                                            // 'Ativo (!)',
                                            // 'Moeda (!)',
                                            // 'PreÃ§o (!)',
                                            // 'Estoque (!)',
                                            // 'PreÃ§o de Fachada',
                                            // 'CÃ³digo Externo',
                                            // 'CÃ³digo de Barras',
                                            // 'DescriÃ§Ã£o',
                                            // 'DescriÃ§Ã£o Curta',
                                            // 'Meta TÃ­tulo',
                                            // 'Meta Palavras-chave',
                                            // 'Meta DescriÃ§Ã£o',
                                            // 'Meta CanÃ´nica',
                                            // 'Slug',
                                            // 'Redirecionamento',
                                            // 'Exibir',
                                            // 'PesquisÃ¡vel',
                                            // 'CÃ³digo do Fabricante',
                                            // 'Combo',
                                            // 'Data de LanÃ§amento',
                                            // 'Peso',
                                            // 'Altura',
                                            // 'Largura',
                                            // 'Comprimento',
                                            // 'Peso de Envio',
                                            // 'Altura de Envio',
                                            // 'Largura de Envio',
                                            // 'Comprimento de Envio',
                                            // 'Fabricante',
                                            // 'Fornecedor',
                                            // 'Marca',
                                            // 'Unidade',
                                            // 'Cor',
                                            // 'Tamanho',
                                            // 'SKU do Produto Base',
                                            // 'Categorias (separadas por ponto e vÃ­rgula)',
                                        ]} />
                                </div>
                                <ActionButton icon actionType="export" onClick={() => handleExport()}>Baixar Planilha Modelo</ActionButton>
                            </div>
                        </ContentBox>

                        <LoadingWrapper loading={loading} description="Informação de Importação de Produtos">
                            <ContentBox className="mb-4 p-6" description='Informação de Importação de Produtos'>
                                <Table
                                    className="table-custom"
                                    columns={columns}
                                    dataSource={productMassListError?.map((item: any, index: number) => ({
                                        ...item,
                                        key: item.uuid || index,
                                    }))}
                                    loading={loading}
                                    size="middle"
                                    bordered={false}
                                    pagination={false}
                                    showSorterTooltip={{ target: 'sorter-icon' }}
                                />
                            </ContentBox >
                        </LoadingWrapper>

                        <div className="flex justify-end">
                            <ActionButton htmlType="submit" actionType="primary">Processar</ActionButton>
                        </div>
                    </Form>
                </Formik >
            </Permission >

        </>
    );
});

export default CreateMassProductInclusion;